import VariantData from '../selectors/variant-data';

export const track = ({ eventName, data }) => {
  window.dataLayer = window.dataLayer || [];

  window.dataLayer.push({
    event: eventName,
    ...data
  });
};

const TRACK_AND_WAIT_TIMEOUT_MS = 1500;

// Resolves once GTM has processed the event, or after the timeout when GTM is blocked or not loaded yet.
// Never rejects, so a tracking failure cannot block navigation.
export const trackAndWait = ({ eventName, data, timeoutMs = TRACK_AND_WAIT_TIMEOUT_MS }) => new Promise((resolve) => {
  setTimeout(resolve, timeoutMs);

  try {
    track({
      eventName,
      data: {
        ...data,
        eventCallback: () => resolve(),
        eventTimeout: timeoutMs
      }
    });
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error('Error:', error);
    resolve();
  }
});

export const userId = () => window.__st.cid; // eslint-disable-line no-underscore-dangle

export const parsePageType = (classList) => {
  if (classList.contains('index')) {
    return 'Home';
  }
  if (classList.contains('product')) {
    return 'Product';
  }
  if (classList.contains('collection')) {
    return 'Collection';
  }
  if (classList.contains('reviews')) {
    return 'Product Review';
  }
  if (classList.contains('science')) {
    return 'Product Technical';
  }
  if (classList.contains('article')) {
    return 'Article';
  }
  if (classList.contains('blog')) {
    return 'Blog';
  }
  return 'Default';
};

export const formatDate = ({ date }) => date.toISOString();

export const currentDate = () => formatDate({ date: new Date() });

export const getVariantData = (variantId) => {
  const variantData = new VariantData();
  const data = variantData.getData(variantId);
  const purchaseType = data.subscriptionId ? 'Subscription' : 'One-time Order';

  return {
    purchaseType,
    ...data
  };
};

export const getGlobalSubscriptionState = () => window.currentVariantStorage.getState().subscription;

export const getCustomerData = () => {
  if (userId() && window?.customerDataSelector?.getData(userId())) {
    const {
      firstName,
      lastName,
      id,
      email
    } = window.customerDataSelector.getData(userId());

    return {
      firstName,
      lastName,
      id,
      email,
      logged_in: 'true'
    };
  }

  return null;
};

export const BRAND = 'Ketone-IQ';

export default {
  track,
  trackAndWait,
  userId,
  parsePageType,
  formatDate,
  currentDate,
  BRAND,
  getVariantData,
  getGlobalSubscriptionState,
  getCustomerData
};
